<form-intro
  title="{{ 'onboarding.lastNameFormGreeting' | translate: { name: firstName } }}"
  imagePath="assets/images/emojis/1f64c.svg"
></form-intro>
<form [formGroup]="form" novalidate id="last-name-form">
  <mat-form-field class="w-full" appearance="outline">
    <input
      timedAutofocus
      [delay]="tabAnimationDuration"
      matInput
      formControlName="name"
      placeholder="{{ 'onboarding.lastName' | translate }}"
    />

    <button
      type="button"
      (click)="form.controls.name.reset()"
      *ngIf="form.controls.name.value"
      mat-icon-button
      matSuffix
    >
      <mat-icon>{{ 'close' }}</mat-icon>
    </button>

    <mat-error *ngIf="form.controls.name.invalid">
      <span *ngIf="form.controls.name.hasError('required')">{{
        'formValidation.requiredError' | translate: { field: 'onboarding.lastName' | translate }
      }}</span>
      <span *ngIf="form.controls.name.hasError('minlength')">
        {{
          'formValidation.minLengthError'
            | translate
              : {
                  field: 'onboarding.lastName' | translate,
                  value: form.controls.name.errors?.minlength.requiredLength
                }
        }}
      </span>
      <span *ngIf="form.controls.name.hasError('invalidCharacters')">
        {{ 'formValidation.aToZError' | translate }}
      </span>
    </mat-error>
  </mat-form-field>
</form>
